import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { makeDoctorsEdit } from '../../../../usecases/doctors/remote-doctors-factory'
import { useMe } from '../../../../../presentation/contexts/me'
import { makeUsers } from '../../../../usecases/users/remote-users-factory'
import EditAvailability from '../../../../../presentation/pages/doctors/profile/editAvailability'

const initialStateAvailability = [
  {
    dayWeek: 'SUNDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'MONDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'TUESDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'WEDNESDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'THURSDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'FRIDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
  {
    dayWeek: 'SATURDAY',
    morning: false,
    afternoon: false,
    night: false,
  },
]

const MakeEditAvailability = () => {
  document.title = 'BuscarMédicos - Editar endereço'

  const history = useHistory()

  const [errorMessage] = useState<string | null>('')

  const { me } = useMe()

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    document: [
      {
        id: 0,
        url: '',
      },
    ],
  })

  const [selectedValues, setSelectedDates] = useState<
    Array<{
      dayWeek: string
      morning: boolean
      afternoon: boolean
      night: boolean
    }>
  >(initialStateAvailability)

  useEffect(() => {
    const fetchData = async () => {
      if (!me) {
        return
      }

      try {
        const response = await makeUsers().loadDoctorById(me.id)
        setUser(response)
      } catch (error) {
        toast.error('Erro ao carregar dados do usuário.')
      }
    }

    fetchData()
  }, [me])

  const options = [
    {
      label: 'Domingo',
      subOptions: ['Dom/Manhã', 'Dom/Tarde', 'Dom/Noite'],
    },
    {
      label: 'Segunda',
      subOptions: ['Seg/Manhã', 'Seg/Tarde', 'Seg/Noite'],
    },
    {
      label: 'Terça',
      subOptions: ['Ter/Manhã', 'Ter/Tarde', 'Ter/Noite'],
    },
    {
      label: 'Quarta',
      subOptions: ['Qua/Manhã', 'Qua/Tarde', 'Qua/Noite'],
    },
    {
      label: 'Quinta',
      subOptions: ['Qui/Manhã', 'Qui/Tarde', 'Qui/Noite'],
    },
    {
      label: 'Sexta',
      subOptions: ['Sex/Manhã', 'Sex/Tarde', 'Sex/Noite'],
    },
    {
      label: 'Sábado',
      subOptions: ['Sab/Manhã', 'Sab/Tarde', 'Sab/Noite'],
    },
  ]

  const handleSelectDates = (data: any) => {
    const isValidKey = (
      key: string,
      obj: Record<string, any>,
    ): key is keyof typeof obj => key in obj

    const dayWeekMapper: Record<string, string> = {
      Dom: 'SUNDAY',
      Seg: 'MONDAY',
      Ter: 'TUESDAY',
      Qua: 'WEDNESDAY',
      Qui: 'THURSDAY',
      Sex: 'FRIDAY',
      Sab: 'SATURDAY',
    }

    const periodMapper: Record<string, string> = {
      Manhã: 'morning',
      Tarde: 'afternoon',
      Noite: 'night',
    }

    const [dayWeek, period] = data.split('/')

    setSelectedDates((prevAvailability) => prevAvailability.map((day) => {
      if (
        day.dayWeek === dayWeekMapper[dayWeek]
          && period
          && isValidKey(period, periodMapper)
      ) {
        return {
          ...day,
          [periodMapper[period]]:
              !day[periodMapper[period] as keyof typeof day],
        }
      }
      return day
    }))
  }

  const dataForm = [
    {
      items: [
        {
          name: 'dates',
          component: 'Multiselect',
          options,
          onSelect: handleSelectDates,
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar alterações',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (): Promise<void> => {
    try {
      if (me !== null) {
        await makeDoctorsEdit().update(me.id, {
          availability: selectedValues,
        })
        history.goBack()
      } else {
        console.error('Variável "me" é nula.')
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error)
    }
  }

  const imageUrl = user.document.find((doc) => doc.url.startsWith('images/'))?.url

  const name = `${user.firstName} ${user.lastName}`

  return (
    <EditAvailability
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      name={name}
      email={user.email}
      phone={user.phone}
      imageUrl={imageUrl}
    />
  )
}

export default MakeEditAvailability
